// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"542c9d24","122":"157f7950","310":"57aa3684","375":"45c51f3a","416":"a0439a33","538":"20cdb9f7","614":"ea0a9b10","637":"4e616eae","877":"7c7592a7"}[chunkId] + ".chunk.js";
};